import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, bool_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class AnatomyOrientationProps extends Record {
    constructor(showOrientation) {
        super();
        this.showOrientation = showOrientation;
    }
}

export function AnatomyOrientationProps_$reflection() {
    return record_type("RAWMap.Client.Visualization.AnatomyOrientation.Bindings.AnatomyOrientationProps", [], AnatomyOrientationProps, () => [["showOrientation", bool_type]]);
}

